import type { ActionCandidate } from "../types/candidate";

/**
 * A `recordList` that is present but carries no source is an action whose
 * records source was never chosen. The engine cannot resolve it, so every run
 * of the automation fails.
 *
 * An absent `recordList` is a different thing — the engine falls back to the
 * trigger's records — so only the empty config counts as missing.
 */
export const recordSourceMissing = (action: ActionCandidate): boolean =>
  action.recordList !== undefined &&
  action.recordList.recordList.oneofKind === undefined;
